module.exports = __webpack_public_path__ + "img/12.6f6775c7.png";